import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'epic-diesel-common';
import {connect} from 'react-redux';

import styles from './TaxProfile.pcss';
import Message, {getMessage} from '../../common/Message';
import TaxRecordDialog from '../../payout/TaxRecordDialog';
import TaxRecordProfile from '../../payout/TaxRecordProfile';
import Consent from '../../payout/Consent';
import {LoadIndicator, PayoutForm} from '../../index';
import taxActions from '../../../actions/tax.actions';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    taxState: state.get('tax').toJS()
});

const mapDispatchToProps = {
    fetchOrganizations: taxActions.getOrganizations,
    fetchRecord: taxActions.getTaxRecord,
    updateRecord: taxActions.updateTaxRecord,
    refreshRecord: taxActions.refreshTaxRecord,
    getConsent: taxActions.getConsent,
    resetInterview: taxActions.resetInterview,
    consentForPayment: taxActions.consentForPayment,
    getBalancePayable: taxActions.getBalancePayable
};

const TaxProfile = ({
    messages,
    form,
    fetchOrganizations,
    taxState,
    resetInterview,
    fetchRecord,
    updateRecord,
    getConsent,
    getBalancePayable,
    consentForPayment
}) => {
    const [open, setOpen] = useState(false);
    const isVerified = taxState.verified;
    const receiveMessage = event => {
        if (event.data && event.data === 'exitConfirmed') {
            setTimeout(() => resetInterview(), 1000);
        }
    };

    useEffect(() => {
        fetchRecord();
        getConsent();
        fetchOrganizations();
        window.addEventListener('message', receiveMessage, false);
    }, []);

    useEffect(() => {
        getConsent();
        getBalancePayable();
    }, [taxState.record]);

    const InterviewInfo = () => {
        const privacyPolicyLink = 'https://www.epicgames.com/site/en-US/privacypolicy';
        const _desc = getMessage(messages, 'epic.affiliate.settings.tax.profile.desc', [
            privacyPolicyLink
        ]);
        const code = isVerified ? 'epic.affiliate.settings.tax.profile.under_review' :
            'epic.affiliate.settings.tax.profile.new_interview';
        return (
            <>
                <LoadIndicator
                    messages={messages}
                    isLoading={taxState.loading}
                    className={styles.section}>
                    <div className={styles.title}>
                        <Message code="epic.affiliate.settings.tax.profile.title" />
                    </div>
                    <div dangerouslySetInnerHTML={{__html: _desc}} />
                    <div className={styles.profileInfo}>
                        <Message code={code} />
                    </div>
                    <Button
                        disabled={isVerified}
                        onClick={() => setOpen(true)}
                        className={styles.submitButton}>
                        <Message code="epic.affiliate.settings.tax.profile.begin.interview" />
                    </Button>
                </LoadIndicator>
            </>
        );
    };

    const ProfileInfo = () => {
        return ([
            <TaxRecordProfile
                key="profile"
                validated={taxState.validated}
                retakeAvailable={taxState.retakeAvailable}
                onOpen={() => setOpen(true)}
                taxRecord={taxState.record}
                updateRecord={updateRecord}
                messages={messages}
            />,
            <Consent
                key="consent"
                messages={messages}
                consentForPayment={consentForPayment}
                isConsent={taxState.isConsent}
            />
        ]);
    };

    return [
        taxState.isOffline && <PayoutForm />,
        ((isVerified && taxState.retakeAvailable) || taxState.validated) ? (
            <ProfileInfo key="profileInfo" />
        ) : (
            <InterviewInfo key="interviewInfo" messages={messages} />
        ),
        open && <TaxRecordDialog
            organizations={taxState.organizations}
            open={open}
            isVerified={isVerified}
            key="dialog"
            onClose={() => setOpen(false)}
            form={form}
        />
    ];
};

TaxProfile.propTypes = {
    messages: PropTypes.object,
    form: PropTypes.object,
    fetchOrganizations: PropTypes.func,
    fetchTaxRecord: PropTypes.func,
    fetchRecord: PropTypes.func,
    taxState: PropTypes.object,
    resetInterview: PropTypes.func,
    getConsent: PropTypes.func,
    getBalancePayable: PropTypes.func,
    consentForPayment: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TaxProfile);
